/** The English name of a country from its ISO 3166 code ("ES" → "Spain"); the code itself when it is not known. */
export function countryName(code: string): string {
  if (!/^[A-Za-z]{2}$/.test(code)) return code
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(code.toUpperCase()) ?? code
  } catch {
    return code
  }
}
